import { useEffect, useRef } from "react";
import { Box, Button, Paper, Typography } from "@mui/material";

interface Props {
  value: string;
  onChange: (value: string) => void;
}

export default function RichTextLessonEditor({ value, onChange }: Props) {
  const editor = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (editor.current && editor.current.innerHTML !== value) editor.current.innerHTML = value;
  }, [value]);

  const command = (name: string, argument?: string) => {
    editor.current?.focus();
    document.execCommand(name, false, argument);
    onChange(editor.current?.innerHTML || "");
  };

  return (
    <Paper variant="outlined" sx={{ mt: 2, overflow: "hidden", borderRadius: "10px", borderColor: "#aa7b67", "&:focus-within": { borderColor: "#614438" } }}>
      <Box sx={{ display: "flex", gap: 0.5, p: 1, bgcolor: "action.hover", flexWrap: "wrap" }}>
        <Button size="small" onClick={() => command("bold")}><strong>Bold</strong></Button>
        <Button size="small" onClick={() => command("italic")}><em>Italic</em></Button>
        <Button size="small" onClick={() => command("formatBlock", "h2")}>Heading</Button>
        <Button size="small" onClick={() => command("insertUnorderedList")}>Bullets</Button>
        <Button size="small" onClick={() => command("insertOrderedList")}>Numbered</Button>
        <Button size="small" onClick={() => command("removeFormat")}>Clear formatting</Button>
      </Box>
      <Box ref={editor} contentEditable suppressContentEditableWarning
        onInput={() => onChange(editor.current?.innerHTML || "")}
        sx={{ minHeight: 220, p: 2, outline: "none", lineHeight: 1.7,
          "&:empty:before": { content: '"Write or paste the lesson content here…"', color: "text.disabled" } }} />
      <Typography variant="caption" color="text.secondary" sx={{ display: "block", px: 2, pb: 1 }}>
        Formatting is preserved and displayed safely to learners.
      </Typography>
    </Paper>
  );
}
